import { render } from "./AdditionalContact.vue?vue&type=template&id=c0804d5e"
import script from "./AdditionalContact.vue?vue&type=script&lang=js"
export * from "./AdditionalContact.vue?vue&type=script&lang=js"
script.render = render

export default script